<a routerLink="/">
  <img src="../../assets/logowhite.svg" alt="dots n pix logo" id="logoSmall">
</a>
<a (click)="rotate(1)" id="left">
  <</a> <a (click)="rotate(-1)" id="right">>
</a>
<img src="../../assets/smallRocket.svg" alt="rocket" id="rocket">
<div id="cutoff">
  <div id="rotatingPlanet">
    <a routerLink="/speakers">
      <div class="building" id="speakers">Speakers</div>
    </a>
    <a routerLink="/schedule">
      <div class="building" id="schedule">Schedule</div>
    </a>
    <a routerLink="/practical">
      <div class="building" id="practical">Practical</div>
    </a>
    <a routerLink="/about">
      <div class="building" id="about">About</div>
    </a>
    <a routerLink="/coaching">
      <div class="building" id="coaching">Coaching Sessions</div>
    </a>
    <a routerLink="/partners">
      <div class="building" id="partners">Partners</div>
    </a>
    <img src="../../assets/emptyplanet.svg" alt="empty planet"></div>
</div>
